<template>
  <div class="project-list">
    <p class="alert-info">
      移动端仅支持询盘管理项目，其他项目类型请用电脑操作
    </p>
    <template v-if="datas.length > 0">
      <project-item
        v-for="(item,index) in datas"
        :key="index"
        :pro-item-data="item"
        :cid="$route.query.cid * 1"
        :baseinfo="baseinfo"
      />
      <div
        v-if="baseinfo.isadmin===1 || baseinfo.isfounder===1"
        class="create-box"
      >
        <cube-button
          :light="true"
          @click="creatPro"
        >
          {{ $t('message["127"]') }}
        </cube-button>
      </div>
    </template>
    <div
      v-else
      class="empty-pro-box"
    >
      <img src="../../assets/images/empty.png">
      <p class="placeholder">
        当前组织下，未参与询盘管理项目
      </p>
      <p>
        <cube-button
          v-if="(baseinfo.isadmin===1 || baseinfo.isfounder===1)"
          :primary="true"
          @click="creatPro"
        >
          {{ $t('message["127"]') }}
        </cube-button>
      </p>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import ProjectItem from './ProjectItem'
export default {
  components: {
    ProjectItem
  },
  props: {
    datas: {
      type: Array,
      default () {
        return []
      }
    },
    baseinfo: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {}
  },
  computed: {
    ...mapState('organization/org', ['datasReady']),
    page () {
      return this.$route.query.page
    }
  },
  methods: {
    ...mapActions('organization/org', ['fetchProjectList']),
    creatPro () {
      this.$router.push({
        name: 'ProjectIndexPc',
        query: {
          page: 3,
          cid: this.$route.query.cid,
          type: this.$route.query.type || 'inquery'
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.empty-pro-box {
  width: 273px;
  margin: 130px auto 0;
  text-align: center;
  img {
    width: 137px;
    margin: 0 auto 14px;
  }
  .placeholder {
    margin-bottom: 24px;
    font-size: 16px;
    color: #999;
  }
}
.create-box {
  margin: 0 12px;
}
</style>
